import { render, staticRenderFns } from "./juzgados.vue?vue&type=template&id=0e27fc28&scoped=true"
import script from "./juzgados.vue?vue&type=script&lang=js"
export * from "./juzgados.vue?vue&type=script&lang=js"
import style0 from "./juzgados.vue?vue&type=style&index=0&id=0e27fc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e27fc28",
  null
  
)

export default component.exports